import type { Address } from '@/types';

interface FormattedAddressProps {
  addressData: Address;
}

export const FormattedAddress = ({ addressData }: FormattedAddressProps) => (
  <p translate="no">
    {addressData.firstName} {addressData.lastName}
    <br />
    {addressData.company ? (
      <>
        {addressData.company}
        <br />
      </>
    ) : null}
    {addressData.line1}
    <br />
    {addressData.line2 ? (
      <>
        {addressData.line2}
        <br />
      </>
    ) : null}
    {addressData.city}
    <br />
    {addressData.countyName ? (
      <>
        {addressData.countyName}
        <br />
      </>
    ) : null}
    {addressData.postalCode}
    <br />
    {addressData.countryName}
  </p>
);
